export const PRICE_BUCKET_FILTER_ITEMS = [
  { count: 0, end: 19.99, label: 'Under $20', value: ':19.99' },
  { count: 0, end: 39.99, label: '$20-40', start: 20, value: '20:39.99' },
  { count: 0, end: 59.99, label: '$40-60', start: 40, value: '40:59.99' },
  { count: 0, end: 79.99, label: '$60-80', start: 60, value: '60:79.99' },
  { count: 0, label: '$80 & above', start: 80, value: '80:' },
];

export const RATING_FILTER_ITEMS = [
  { count: 0, label: '4', start: 4, value: '4:' },
  { count: 0, label: '3', start: 3, value: '3:' },
  { count: 0, label: '2', start: 2, value: '2:' },
  { count: 0, label: '1', start: 1, value: '1:' },
];
